import React, { forwardRef } from "react";
import clsx from "clsx";

type InputProps = React.InputHTMLAttributes<HTMLTextAreaElement> & {
  hasError?: boolean;
};

const Textarea = forwardRef<HTMLTextAreaElement, InputProps>(({ hasError, className, disabled, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={clsx(
        "h-32 w-full rounded-md border px-3.5 py-2.5 text-sm text-primary shadow-xs outline-none transition duration-75 placeholder:text-placeholder hover:shadow-xs active:shadow-xs disabled:bg-disabled",
        hasError ? "border-error-subtle" : "border-primary",
        className,
      )}
      disabled={disabled}
      {...props}
    />
  );
});

export default Textarea;
